var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconStar = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m8.456 1.25 2.09 4.143 4.026.399a.503.503 0 0 1 .312.859l-3.312 3.283 1.228 4.461a.507.507 0 0 1-.72.584L8 12.96l-4.075 2.018a.508.508 0 0 1-.72-.585l1.229-4.46-3.315-3.284a.503.503 0 0 1 .312-.859l4.025-.398L7.544 1.25a.512.512 0 0 1 .912 0"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m8.456 1.25 2.09 4.143 4.026.399a.503.503 0 0 1 .312.859l-3.312 3.283 1.228 4.461a.507.507 0 0 1-.72.584L8 12.96l-4.075 2.018a.508.508 0 0 1-.72-.585l1.229-4.46-3.315-3.284a.503.503 0 0 1 .312-.859l4.025-.398L7.544 1.25a.512.512 0 0 1 .912 0"
  }));
});
export default SvgIconStar;
export const raw = __webpack_public_path__ + "static/media/IconStar.191ad096cfe875917794a8cb97136f9c.svg";